import Japan from "./Japan";
import UnitedStates from "./UnitedStates";
import China from "./China";
import Vietnam from "./Vietnam";
import Thailand from "./Thailand";
import Indonesia from "./Indonesia";
import Bangladesh from "./Bangladesh";
import Pakistan from "./Pakistan";
import Cambodia from "./Cambodia";
import Malaysia from "./Malaysia";

const SupportedCountries:any = {
    Bangladesh,
    Cambodia,
    China,
    Indonesia,
    Japan,
    Malaysia,
    Pakistan,
    Thailand,
    UnitedStates,
    Vietnam,
}

export default SupportedCountries;